import styled from "@emotion/styled";

export const Group = styled.div`
    position: relative;
    width: 100%;
`;

export const Prefix = styled.div`
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    gap: 6px;
    padding-left: 8px;
    pointer-events: none;
    height: 48px;
`;

export const Input = styled.input<{
    hasToggle: boolean;
    hasPrefix: boolean;
    prefixWidth: number;
    hasError: boolean;
    hasEditText: boolean;
}>`
    all: unset;
    box-sizing: border-box;
    width: 100%;
    height: 48px;

    /* ✅ UPDATED TEXT STYLING */
    font-family: Inter;
    font-weight: 500;
    font-style: Medium;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 120%;
    letter-spacing: 0px;
    vertical-align: middle;
    color: #e9ecf5;

    padding: ${({ hasToggle, hasPrefix, prefixWidth, hasEditText }) => {
        const baseRight = hasToggle ? 44 : 12;
        const right = hasEditText ? baseRight + 32 : baseRight;
        const left = hasPrefix ? prefixWidth + 12 : 12;
        return `0 ${right}px 0 ${left}px`;
    }};

    background: #23252a;
    text-align: left;

    border: 2px solid ${({ hasError }) => (hasError ? "#D65F46" : "#2B2D33")};
    border-radius: 8px;

    transition: border-color 0.2s ease, box-shadow 0.2s ease;

    /* ✅ Chrome/Safari autofill fix (pre-filled / password manager / paste suggestions) */
    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
        -webkit-text-fill-color: #e9ecf5 !important;
        caret-color: #e9ecf5;
        -webkit-box-shadow: 0 0 0px 1000px #23252a inset !important;
        box-shadow: 0 0 0px 1000px #23252a inset !important;
        background-clip: content-box !important;
        transition: background-color 9999s ease-out 0s;
    }

    &:focus {
        border: 2px solid ${(
        { hasError },
    ) => (hasError ? "#D65F46" : "#5E84ED")};
        box-shadow: 0 0 0 2px ${(
        { hasError },
    ) => (hasError ? "#D65F46" : "#5E84ED")};
        outline: none;
    }

    &:focus + label,
    &:not(:placeholder-shown) + label {
        transform: translateY(-175%) scale(0.85);
        left: 12px;
        color: #b7bdcbb2;
    }
`;

export const Label = styled.label<{
    hasPrefix: boolean;
    prefixWidth: number;
}>`
    left: ${({ hasPrefix, prefixWidth }) => (hasPrefix ? `${prefixWidth + 12}px` : '12px')};
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    padding: 0 8px;
    font-family: Inter;
    font-weight: 500;
    font-size: 14px;
    background: #23252a;
    border-radius: 8px;
    color: #6b7280;
    pointer-events: none;

    transition: transform 0.15s ease, color 0.15s ease, left 0.15s ease;
`;

export const Toggle = styled.button`
    all: unset;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: 0px;
    cursor: pointer;
    line-height: 0;
    color: #b7bdcb;
    width: 50px;
    height: 50px;
    top: 0px;
    
    &:hover {
        color: #4b5563;
    }
`;

export const EditIcon = styled.img`
    position: absolute;
    right: 12px;
    top: 14px;
    bottom: 14px;
    pointer-events: none;
    width: 18px;
    transition: opacity 0.15s ease;

    ${Group}:focus-within & {
        opacity: 0;
    }
`;

export const ErrorText = styled.div`
    padding-top: 5px;
    color: #d65f46;
    font-family: Inter;
    font-weight: 500;
    font-style: Medium;
    font-size: 12px;
    line-height: 120%;
    vertical-align: middle;
`;

export const EyeVisible = styled.img`
    height: 14px;
`;

export const EyeInvisible = styled.img`
    height: 16px;
`;
